import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";
import { formRender, initialValues, adjustmentReasonValidation } from "./adjustment-reason-schema";
import { createAdjustmentReason } from "services/data.internal.service";
import AdjustmentReasonInfo from "./components/AdjustmentReasonInfo";

function AddAdjustmentReason() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const createAdjustmentReasonMutation = useMutation(createAdjustmentReason, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(adjustmentReasonValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    createAdjustmentReasonMutation.mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };
  const createStatus = createAdjustmentReasonMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <AdjustmentReasonInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus}  url="/setup/adjustment-reason" />
      </form>
    </Layout>
  );
}

export default AddAdjustmentReason;
